var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2894 4900 c-141 -21 -289 -102 -383 -207 -62 -70 -126 -189 -146 -274 -10 -44 -15 -119 -15 -242 0 -156 2 -182 19 -215 25 -48 66 -87 113 -106 50 -21 324 -22 423 -1 233 49 435 245 489 475 22 92 22 396 1 448 -20 47 -50 79 -100 105 -35 19 -58 22 -195 24 -85 1 -178 -2 -206 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785 3826 c-568 -94 -1006 -521 -1122 -1094 -26 -124 -25 -547 0 -712 86 -551 346 -1043 745 -1404 105 -95 349 -279 412 -311 142 -72 326 -90 469 -46 41 12 128 49 193 82 182 91 201 90 398 -17 156 -85 236 -108 370 -107 121 0 225 28 321 86 90 54 313 232 422 336 216 207 462 557 482 686 10 58 -10 120 -52 166 -47 52 -56 56 -163 79 -111 24 -188 54 -263 104 -386 256 -431 808 -92 1124 102 96 219 154 368 182 124 23 191 99 191 215 0 72 -12 98 -93 189 -192 217 -447 366 -742 432 -103 24 -357 24 -458 1 -127 -29 -209 -58 -352 -128 l-139 -68 -134 64 c-161 76 -248 108 -352 130 -107 22 -309 28 -409 11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.3d836605744d804282277f57e5d43819.svg";
export { ForwardRef as ReactComponent };